import { render } from "./ViewPersonnellePage.vue?vue&type=template&id=5bed7e1b&ts=true"
import script from "./ViewPersonnellePage.vue?vue&type=script&lang=ts"
export * from "./ViewPersonnellePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__